var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOnlyLarge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 97,
    viewBox: "0 0 72 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.90918,
    y: 29.4092,
    width: 62.1818,
    height: 62.1818,
    rx: 14.4018,
    fill: "url(#paint0_linear_249_142)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5254 43.6578C36.002 45.8327 36.6856 49.4037 35.83 51.9686C33.767 58.1528 28.9866 56.0564 24.7824 56.782C20.22 57.5694 17.5202 63.5455 19.1147 68.281C20.7092 73.0166 26.793 76.2186 33.1992 76.0452C42.2339 75.8006 50.9889 67.9616 52.4315 57.2764C53.874 46.5911 45.3568 41.3347 40.5254 43.6578Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_142",
    x1: 61.8296,
    y1: 91.5909,
    x2: 41.7096,
    y2: 23.3104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0259369,
    stopColor: "#B89DF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230937,
    stopColor: "#9E7CC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#352E8F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOnlyLarge);
export default __webpack_public_path__ + "static/media/logo-only-large.7ae995279286ef15fb91e6c4022730b5.svg";
export { ForwardRef as ReactComponent };